import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import type { PipelineHistoryField, PipelineHistoryFieldChange } from '@repo/lakehouse-sdk';
import { Table } from '@/components/table';
import { Tag } from '@/components/tag';
import { pluralize } from '@/utils/string';
import { HISTORY_CHANGE_COLUMNS } from './historyChangeColumns';
import { historyChangeRows } from './historyChangeRows';
import { changesView } from './historyView';
export const HistoryChanges = t0 => {
  const $ = _c(7);
  const {
    changes,
    snapshot
  } = t0;
  let t1;
  if ($[0] !== changes || $[1] !== snapshot) {
    const rows = historyChangeRows(changes, snapshot);
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        gap: "20px"
      };
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        gap: "8px",
        flexWrap: "wrap"
      };
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    const t4 = `${rows.length} ${pluralize("change", rows.length)}`;
    let t5;
    if ($[5] !== t4) {
      t5 = <Tag content={t4} />;
      $[5] = t4;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t1 = <Stack sx={t2}><Stack direction="row" sx={t3}>{t5}{["Added", "Removed", "Modified"].map(kind => {
          const count = rows.filter(change => change.kind === kind).length;
          return count ? <Tag key={kind} content={`${count} ${kind.toLowerCase()}`} variant={kind === "Added" ? "success" : kind === "Removed" ? "error" : "secondary"} /> : null;
        })}</Stack>{!rows.length && <Typography variant="body2">No configuration changes.</Typography>}{changesView(rows).map(_temp)}</Stack>;
    $[0] = changes;
    $[1] = snapshot;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
function _temp(group) {
  return <Stack key={group.title} sx={{
    gap: "8px"
  }}><Typography variant="subtitle1Strong">{group.title}</Typography><Table testId={`history-changes-${group.title}`} data={group.changes} columns={HISTORY_CHANGE_COLUMNS} isLoading={false} entityLabel="configuration changes" isMultiSelect={false} disableSorting={true} /></Stack>;
}